import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import FormHead from '@/components/common/Form/FormHead';
import FieldLayout from '@/components/Layout/FieldLayout';
import Button from '@/components/ui/Button';
import PrimaryInput from '@/components/ui/PrimaryInput';
import {
  IAddEmployeeForm,
  IEmployeeOnBoardResponse,
} from '@/interfaces/employee.model';
import { showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
interface IEmployeeAdvanceDetailsStep3Props {
  empId: string | null;
  nextStep: () => void;
}
const EmployeeAdvanceDetailsStep3 = ({
  empId,
  nextStep,
}: IEmployeeAdvanceDetailsStep3Props) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    trigger,
    getValues,
    formState: { errors },
  } = useFormContext<IAddEmployeeForm>();
  const handleNextStep = async () => {
    const isValid = await trigger([
      'aadharNumber',
      'panNumber',
      'insuranceNumber',
      'pfNumber',
      'drivingLicenseNumber',
      'esicNumber',
      'uanNumber',
    ]);
    const formData = new FormData();
    if (isValid && empId) {
      const data = getValues();
      setIsLoading(true);
      formData.append('uanNumber', data?.uanNumber);
      formData.append('aadharNumber', data?.aadharNumber);
      formData.append('esicNumber', data?.esicNumber);
      formData.append('drivingLicenseNumber', data?.drivingLicenseNumber);
      formData.append('insuranceNumber', String(data?.insuranceNumber));
      formData.append('panNumber', String(data?.panNumber));
      formData.append('pfNumber', String(data?.pfNumber));
      try {
        const response: IEmployeeOnBoardResponse = await callApi(
          API_URL + API_ENDPOINT.addEmployee + `?userId=${empId}`,
          { method: 'POST', data: formData, multipart: true },
        );
        if (response?.status) {
          showToastNotification('success', response?.message);
          nextStep();
        }
      } catch (error) {
        if (error && typeof error === 'object' && 'message' in error) {
          showToastNotification('danger', (error as IApiErrorResponse).message);
        } else {
          showToastNotification('danger', 'Something went wrong');
        }
      } finally {
        setIsLoading(false);
      }
    }
  };
  return (
    <>
      <div className="row">
        <FormHead heading="Advance Details" />
        <FieldLayout fieldStyle="col-lg-4">
          <PrimaryInput
            required={true}
            errors={errors?.aadharNumber?.message}
            id="aadharNum"
            label="Aadhar Number"
            maxLength={12}
            placeholder="Aadhar number"
            {...register('aadharNumber', {
              ...errorTypes.required('Aadhar number'),
              ...errorTypes.aadhaar,
            })}
            onInput={(e: React.FormEvent<HTMLInputElement>) => {
              e.currentTarget.value = e.currentTarget.value
                .replace(/\s/g, '')
                .replace(/[^0-9]/g, '');
            }}
          />
          {/* <label htmlFor="aadharNum" className="form-label">
            Aadhar Number
            <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Aadhar Number"
            id="aadharNum"
            aria-describedby="emailHelp"
            maxLength={12}
            {...register('aadharNumber', {
              ...errorTypes.required('Aadhar number'),
              ...errorTypes.aadhaar,
            })}
            onInput={(e) => {
              e.target.value = e.target.value
                .replace(/\s/g, '')
                .replace(/[^0-9]/g, '');
            }}
          />
          <ErrorMessage message={errors?.aadharNumber?.message} /> */}
        </FieldLayout>
        <FieldLayout fieldStyle="col-lg-4">
          <PrimaryInput
            required={true}
            id="panNum"
            label="PAN Number"
            maxLength={12}
            errors={errors?.panNumber?.message}
            placeholder="Enter pan number"
            {...register('panNumber', {
              ...errorTypes.required('Pan card number'),
              ...errorTypes.pan,
            })}
            onInput={(e: React.FormEvent<HTMLInputElement>) => {
              e.currentTarget.value = e.currentTarget.value
                .replace(/\s/g, '')
                .toUpperCase()
                .slice(0, 10);
            }}
          />
        </FieldLayout>
        {/* <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="panNum" className="form-label">
              PAN Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="PAN Number"
              id="panNum"
              {...register('panNumber', {
                ...errorTypes.required('Pan card number'),
                ...errorTypes.pan,
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/\s/g, '')
                  .toUpperCase()
                  .slice(0, 10); // Convert to uppercase and limit to 10 characters
              }}
            />

            <ErrorMessage message={errors?.panNumber?.message} />
          </div>
        </div> */}
        <FieldLayout fieldStyle="col-lg-4">
          <PrimaryInput
            errors={errors?.uanNumber?.message}
            label="UAN Number"
            maxLength={12}
            placeholder="Enter uan number"
            id="UANno"
            aria-describedby="emailHelp"
            {...register('uanNumber', {
              ...errorTypes.uanNumber,
            })}
            onInput={(e: React.FormEvent<HTMLInputElement>) => {
              e.currentTarget.value = e.currentTarget.value
                .replace(/\s/g, '')
                .replace(/[^0-9]/g, '')
                .slice(0, 12);
            }}
          />
        </FieldLayout>
        {/* <div className="col-12 col-md-6 col-lg-4">
          <div className="form-group mb-3">
            <label htmlFor="UANno" className="form-label">
              UAN no.
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="UAN no."
              id="UANno"
              aria-describedby="emailHelp"
              {...register('uanNumber', {
                ...errorTypes.uanNumber,
              })}
              onInput={(e) => {
                e.target.value = e.target.value
                  .replace(/\s/g, '')
                  .replace(/[^0-9]/g, '')
                  .slice(0, 12);
              }}
            />
            <ErrorMessage message={errors?.uanNumber?.message} />
          </div>
        </div> */}
        <FieldLayout fieldStyle="col-lg-4">
          <PrimaryInput
            errors={errors?.esicNumber?.message}
            label="ESIC Number"
            placeholder="Enter esic number"
            id="ESICNum"
            aria-describedby="emailHelp"
            {...register('esicNumber', {
              ...errorTypes.esic,
            })}
            onInput={(e: React.FormEvent<HTMLInputElement>) => {
              e.currentTarget.value = e.currentTarget.value
                .replace(/\s/g, '')
                .replace(/[^0-9]/g, '')
                .slice(0, 17);
            }}
          />
        </FieldLayout>
        <FieldLayout fieldStyle="col-lg-4">
          <PrimaryInput
            type="number"
            label="PF Number"
            placeholder="Enter pf number"
            id="PFnum"
            errors={errors?.pfNumber?.message}
            maxLength={25}
            {...register('pfNumber', { ...errorTypes.pfNumber })}
          />
        </FieldLayout>
        <FieldLayout fieldStyle="col-lg-4">
          <PrimaryInput
            type="text"
            label="Insurance Number"
            placeholder="Enter insurance number"
            id="InsuranceNum"
            errors={errors?.insuranceNumber?.message}
            maxLength={25}
            {...register('insuranceNumber', { ...errorTypes.insuranceNumber })}
          />
        </FieldLayout>
        <FieldLayout fieldStyle="col-lg-4">
          <PrimaryInput
            label="Driving License Number"
            id="Drive"
            placeholder="Driving license number"
            {...register('drivingLicenseNumber', {
              ...errorTypes.drivingLicense,
            })}
            errors={errors?.drivingLicenseNumber?.message}
            onInput={(e: React.FormEvent<HTMLInputElement>) => {
              e.currentTarget.value = e.currentTarget.value
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, '')
                .slice(0, 17);
            }}
          />
        </FieldLayout>
      </div>
      <div className="d-flex align-items-center justify-content-end">
        <Button
          isLoading={isLoading}
          className="btn btn-primary px-4"
          type="button"
          onClick={handleNextStep}
        >
          Save and Continue
        </Button>
      </div>
    </>
  );
};
export default EmployeeAdvanceDetailsStep3;
